'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _CheckboxComponent = require('../input/CheckboxComponent');

var _CheckboxComponent2 = _interopRequireDefault(_CheckboxComponent);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TugoGroupedCheckbox = function (_React$Component) {
  _inherits(TugoGroupedCheckbox, _React$Component);

  function TugoGroupedCheckbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TugoGroupedCheckbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TugoGroupedCheckbox.__proto__ || Object.getPrototypeOf(TugoGroupedCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this.question = function () {
      return [{
        key: 'mq3',
        text: '3. Have you had any of these conditions in the last 12 months? Choose a condition if, in the specified timeframe, you had the condition, whether or not you received any medical care for it. This includes conditions controlled or managed by medication, a medical device, diet or exercise.',
        hint: 'Choose all applicable conditions, even if you were diagnosed more than 12 months ago. This includes conditions controlled or managed my medication, a medical device such as a stent or pacemaker, diet, or exercise. For example, if you have Coronary Artery Disease (CAD) or Peripheral Vascular Disease (PVD) THAT\'S managed with a stent, choose the applicable condition(s).',
        hintTitle: '',
        options: [{
          group: 'CARDIOVASCULAR',
          key: 'QT-TUP-3A',
          items: [{
            value: 'q4a1',
            text: 'Aortic aneurysm that is 4cm or larger'
          }, { value: 'q4a2', text: 'Angina' }, {
            value: 'q4a3',
            text: 'Congestive heart failure also known as pulmonary edema'
          }, {
            value: 'q4a4',
            text: 'Coronary Artery Disease (CAD)',
            hint: 'Coronary Artery Disease involves blockages in the coronary arteries of the heart and/or decreased pumping action of the heart. It can be caused by arteriosclerosis and/or atherosclerosis. If you’ve been diagnosed with CAD and arteriosclerosis and/or atherosclerosis, choose all these conditions. In addition, if you’ve been diagnosed with Peripheral Vascular Disease (PVD), you need to choose this condition too.'
          }, { value: 'q4a5', text: 'Deep Vein Thrombosis (DVT)' }, {
            value: 'q4a6',
            text: 'Arteriosclerosis and/or atherosclerosis also known as hardening of the arteries'
          }, {
            value: 'q4a7',
            text: 'Peripheral Vascular Disease (PVD)',
            hint: 'Peripheral Vascular Disease involves blockages in the arteries of the legs and/or feet. PVD can also very rarely involve blockages in the arms and/or hands.'
          }, {
            value: 'q4a8',
            text: 'Atrial fibrillation',
            hint: 'Atrial fibrillation is a type of arrhythmia. Choose this condition if you’ve been diagnosed specifically with atrial fibrillation and not any other type of arrhythmia or dysrhythmia.'
          }, { value: 'q4a9', text: 'High cholesterol' }, { value: 'q4a10', text: 'None' }]
        }, {
          group: 'RESPIRATORY',
          key: 'QT-TUP-3B',
          items: [{
            value: 'q5a1',
            text: 'Asthma requiring prednisone',
            hint: 'If in the last 12 months you switched from having asthma requiring prednisone to asthma not requiring prednisone, or vice versa, you only need to choose this condition'
          }, {
            value: 'q5a2',
            text: 'Asthma not requiring prednisone',
            hint: 'If you’ve been diagnosed with asthma and did not require prednisone at any time in the last 12 months, only choose this condition. If in the last 12 months you switched from having asthma requiring prednisone to asthma not requiring prednisone, or vice versa, you only need to choose asthma requiring prednisone.'
          }, { value: 'q5a3', text: 'Two or more bronchitis episodes' }, { value: 'q5a4', text: 'Pneumonia' }, {
            value: 'q5a5',
            text: 'Chronic Obstructive Pulmonary Disease (COPD), including emphysema, requiring home oxygen',
            hint: 'If in the last 12 months you switched from having Chronic Obstructive Pulmonary Disease (COPD) requiring the use of home oxygen to COPD not requiring home oxygen, or vice versa, you only need to choose this condition.'
          }, {
            value: 'q5a6',
            text: 'Chronic Obstructive Pulmonary Disease (COPD), including emphysema, not requiring home oxygen',
            hint: 'If you’ve been diagnosed with Chronic Obstructive Pulmonary Disease (COPD) and didn’t require home oxygen at any time in the last 12 months, only choose this condition. If in the last 12 months you switched from having COPD requiring the use of home oxygen to COPD not requiring home oxygen, or vice versa, you only need to choose COPD requiring home oxygen.'
          }, { value: 'q5a7', text: 'None' }]
        }, {
          group: 'GASTROINTESTINAL',
          key: 'QT-TUP-3C',
          items: [{ value: 'q6a1', text: 'Peptic ulcer either stomach or duodenal' }, {
            value: 'q6a2',
            text: 'Crohn’s disease, diverticulitis, inflammatory bowel disease, bowel obstruction and/or ulcerative colitis',
            hint: 'If you’ve only been diagnosed with diverticulosis, don’t choose this condition. However, if you’ve been diagnosed with diverticulitis and diverticulosis, choose this condition.'
          }, {
            value: 'q6a3',
            text: 'Gastroesophageal reflux disease (GERD) also known as chronic acid reflux',
            hint: 'If you’ve been diagnosed with GERD that’s treated with prescribed medication such as proton pump inhibitors to stop the production of acid in the stomach, choose this condition. Don’t choose this condition if you have occasional heartburn or acid reflux that hasn’t been diagnosed as GERD, even if you’re taking over-the-counter medication for it such as TUMS® or Rolaids®.'
          }, { value: 'q6a4', text: 'None' }]
        }, {
          group: 'CANCER',
          key: 'QT-TUP-3D',
          hint: 'Applicable to liver cancer, pancreatic cancer, metastatic cancer or cancer requiring a bone marrow transplant. <br/>If you have pancreatic cancer, liver cancer, any type of cancer that has metastasized or that required a bone marrow transplant that is currently in remission or was in remission at any time within the 12 months before the application date, choose the applicable condition(s).<br/>Applicable to any other cancer <br/>Do not choose this condition if the cancer is in remission at the time of application.',
          items: [{ value: 'q7a1', text: 'Pancreatic cancer' }, { value: 'q7a2', text: 'Liver cancer' }, {
            value: 'q7a3',
            text: 'Any type of cancer that has metastasized or required a bone marrow transplant, excluding pancreatic or liver cancer'
          }, {
            value: 'q7a4',
            text: 'Any other types of cancer. Exclude basal cell and squamous cell skin cancer and/or cancer that is in remission',
            hint: 'The decrease in or the disappearance of signs and symptoms of cancer and/or the removal of cancer as determined by your physician and noted in your medical records. Remission can be complete or partial. Complete remission means the disappearance of all signs or symptoms. Partial remission means a decrease in or disappearance of some, but not all, signs and symptoms.'
          }, { value: 'q7a5', text: 'None' }]
        }]
      }, {
        key: 'mq4',
        text: '4. Have you had any of these conditions in the last 12 months? Choose a condition if, in the specified timeframe, you had the condition, whether or not you received any medical care for it. This includes conditions controlled or managed by medication, a medical device, diet or exercise.',
        hint: 'Choose all applicable conditions, even if you were diagnosed more than 12 months ago. This includes conditions controlled or managed my medication, a medical device such as a stent or pacemaker, diet, or exercise. For example, if you have Coronary Artery Disease (CAD) or Peripheral Vascular Disease (PVD) THAT\'S managed with a stent, choose the applicable condition(s).',
        hintTitle: '',
        options: [{
          group: '',
          key: 'QT-TUP-4',
          items: [{
            value: 'q8a1',
            text: 'Arthritis',
            hint: 'If you’ve been diagnosed with any type of arthritis—such as osteoarthritis, rheumatoid arthritis, or psoriatic arthritis—choose this condition.'
          }, {
            value: 'q8a2',
            text: 'Diabetes requiring insulin',
            hint: 'If in the last 12 months you switched from having diabetes requiring insulin to diabetes not requiring insulin, or vice versa, you only need to choose this condition.'
          }, {
            value: 'q8a3',
            text: 'Diabetes not requiring insulin',
            hint: 'If you’ve been diagnosed with diabetes that’s treated by lifestyle management such as diet, exercise, or medication, but did not require insulin at any time in the last 12 months, only choose this condition. If in the last 12 months you switched from having diabetes requiring insulin to diabetes not requiring insulin, or vice versa, you only need to choose diabetes requiring insulin. Don’t choose this condition if you’ve been diagnosed with Impaired Glucose Intolerance (IGT), also known as pre-diabetes.'
          }, {
            value: 'q8a4',
            text: 'Gallbladder disease, including gallstones'
          }, {
            value: 'q8a5',
            text: 'Hyperthyroidism'
          }, {
            value: 'q8a6',
            text: 'Hypothyroidism'
          }, { value: 'q8a7', text: 'Kidney stones' }, {
            value: 'q8a8',
            text: 'Kidney disease requiring dialysis',
            hint: 'If in the last 12 months you switched from having kidney disease requiring dialysis to kidney disease not requiring dialysis, or vice versa, you only need to choose this condition.'
          }, {
            value: 'q8a9',
            text: 'Kidney disease not requiring dialysis',
            hint: 'If you’ve been diagnosed with kidney disease and did not require dialysis at any time in the last 12 months, only choose this condition. If in the last 12 months you switched from having kidney disease requiring dialysis to kidney disease not requiring dialysis, or vice versa, you only need to choose kidney disease requiring dialysis.'
          }, {
            value: 'q8a10',
            text: 'Dementia including Alzheimer’s disease'
          }, { value: 'q8a11', text: 'Osteoporosis' }, { value: 'q8a12', text: 'Parkinson’s disease(PD)' }, { value: 'q8a13', text: 'Pancreatitis' }, {
            value: 'q8a14',
            text: 'Liver disease, excluding liver cancer'
          }, {
            value: 'q8a15',
            text: 'Two or more bladder infections',
            hint: 'A bladder infection is a specific type of Urinary Tract Infection (UTI). Choose this condition if you’ve had two or more bladder infections, and not any other types of UTIs.'
          }, { value: 'q8a16', text: 'None' }]
        }]
      }];
    }, _this.hintIcon = function (itemHint) {
      var hint = itemHint.includes('<br/>') ? itemHint.split('<br/>').join('\n') : itemHint;
      return _react2.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: 'info-sign',
        className: 'ingle-form-expandable-hint info-button',
        'aria-hidden': 'true',
        title: (0, _translate.t)(hint),
        style: {
          marginLeft: 6,
          cursor: 'help',
          fontSize: '12px',
          color: '#777'
        }
      });
    }, _this.handleCheckboxChange = function (app, groupKey, questionKey, itemValue, itemText, applicantIndex) {
      var _this$props = _this.props,
          updateProp = _this$props.updateProp,
          values = _this$props.values;

      var fieldBase = 'applicant[' + applicantIndex + '].additional_data.mq.' + questionKey + '.' + groupKey;
      var isNone = itemText === 'None';

      var group = _this.question().find(function (q) {
        return q.options.find(function (opt) {
          return opt.key === groupKey;
        });
      });
      var groupKeyForQuestion = group.options.find(function (opt) {
        return opt.key === groupKey;
      });
      if (!group) return;

      var noneKey = groupKeyForQuestion.items.find(function (i) {
        return i.text === 'None';
      }).value;
      var otherItems = groupKeyForQuestion.items.filter(function (i) {
        return i.value !== noneKey;
      });

      var getValue = function getValue(val) {
        return values.applicant[applicantIndex].additional_data.mq[questionKey][groupKey][val];
      };

      var currentVal = getValue(itemValue);

      if (itemValue === noneKey) {
        otherItems.forEach(function (item) {
          updateProp(fieldBase + '.' + item.value, false);
        });
      } else if (currentVal) {
        var noneVal = getValue(noneKey);
        if (noneVal) {
          updateProp(fieldBase + '.' + noneKey, false);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TugoGroupedCheckbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          applicants = _props.applicants,
          fields = _props.fields;

      return _react2.default.createElement(
        'div',
        null,
        this.question().map(function (question, qIdx) {
          return _react2.default.createElement(
            'div',
            { className: 'grouped-questionnaire' },
            _react2.default.createElement(_LabelledInputComponent2.default, {
              inputLabel: question.text,
              hasExpandableHint: !!question.hint,
              expandableHintId: 'mqHint_' + question.key,
              expandableHintTitle: question.hintTitle,
              expandableHintContent: question.hint ? (0, _translate.t)(question.hint) : '',
              expandableHintIsRawHtml: true,
              inputComponent: function inputComponent() {
                return null;
              },
              inputComponentField: {},
              tugoMq: true
            }),
            _react2.default.createElement(
              'table',
              { className: 'mq-checkbox-table ' },
              _react2.default.createElement(
                'tbody',
                null,
                question.options.map(function (group, gIdx) {
                  return _react2.default.createElement(
                    'div',
                    { key: 'group_' + gIdx, className: 'table-padding' },
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        { colSpan: 3 },
                        group.group && (0, _translate.t)(group.group),
                        group.hint && _this2.hintIcon(group.hint)
                      ),
                      applicants.map(function (app, idx) {
                        return _react2.default.createElement(
                          'th',
                          { key: idx },
                          app.first_name.value
                        );
                      })
                    ),
                    group.items.map(function (item, iIdx) {
                      return _react2.default.createElement(
                        'tr',
                        { key: 'row_' + gIdx + '_' + iIdx },
                        _react2.default.createElement(
                          'td',
                          { colSpan: 3 },
                          (0, _translate.t)(item.text),
                          item.hint && _this2.hintIcon(item.hint)
                        ),
                        applicants.map(function (app, aI) {
                          var fieldPath = app.additional_data.mq[question.key][group.key][item.value];
                          return _react2.default.createElement(
                            'td',
                            { key: 'col_' + gIdx + '_' + iIdx + '_' + aI },
                            _react2.default.createElement(_LabelledInputComponent2.default, {
                              hideLabel: true,
                              inputId: 'mq_' + gIdx + '_' + iIdx + '_' + aI,
                              inputComponent: _CheckboxComponent2.default,
                              inputComponentField: fieldPath,
                              inputComponentProps: {
                                htmlLabel: '',
                                isInline: false,
                                onChangeHook: function onChangeHook() {
                                  return _this2.handleCheckboxChange(app, group.key, question.key, item.value, item.text, aI);
                                }
                              }
                            })
                          );
                        })
                      );
                    })
                  );
                })
              )
            )
          );
        })
      );
    }
  }]);

  return TugoGroupedCheckbox;
}(_react2.default.Component);

TugoGroupedCheckbox.propTypes = {
  applicants: _react2.default.PropTypes.array,
  fields: _react2.default.PropTypes.object,
  updateProp: _react2.default.PropTypes.func,
  values: _react2.default.PropTypes.object
};
exports.default = TugoGroupedCheckbox;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/TugoGroupedCheckbox.jsx
// module id = 1670
// module chunks = 0